module.exports = __webpack_public_path__ + "static/media/logo.01a66a47.png";